import { JSXElementConstructor, ReactElement, MouseEvent } from 'react';
import { AnyObject } from 'common/interfaces';
import { CSSProperties } from 'styled-components';

export interface TableComponentProps<TRow> {
  columns: ColumnType<TRow>[];
  rows: Array<RowType<TRow>>;
  sort?: SortType;
  sortParams?: AnyObject;
  rootTag: RootTagType<TRow>;
  minWidth?: number;
  className?: string;
  openedItem?: string;
  maxWidth?: number;
  widthInPercent?: number;
  width?: string;
  loading?: boolean;
  substitutionElement?: ReactElement;
  scrollXEnable?: boolean;
  tableWrapperStyle?: Omit<CSSProperties, 'translate'>;
  rightComponent?: (params: { row: TRow }) => ReactElement;
}

export interface RowProps<TRow> extends Pick<TableComponentProps<TRow>, 'columns' | 'rootTag' | 'rightComponent'> {
  row: RowType<TRow>;
  openedItemId: string;
}

export interface RowExpandableProps<TRow> extends RowProps<TRow> {
  toggleAllAccordions: (id: string) => any;
}

export interface CellProps<TRow> extends Pick<RowProps<TRow>, 'row' | 'openedItemId'> {
  column: ColumnType<TRow>;
  toggle?: (event: MouseEvent<HTMLDivElement>, isDisable: boolean) => void;
}

export type RootTagType<TRow> = {
  name: RootTagName;
  keyName?: string;
  to?: string;
  onClick?: (row: RowType<TRow>, ctrlKeyPressed?: boolean) => any;
  propName: string;
  encode?: boolean;
  expandComponent?: ReactElement<any, string | JSXElementConstructor<any>>;
};

export type SortType = (sortParameter: string) => any;

export type ColumnType<TRow = AnyObject> = {
  name: string;
  type: ColumnsVariant;
  propName?: string;
  sort?: boolean;
  sortName?: string;
  width: string;
  className?: string;
  defaultImage?: string;
  component?: ReactElement;
  hide?: boolean;
  customTooltip?: (row: RowType<TRow>) => any;
  alwaysShowTooltip?: boolean;
  neverShowTooltip?: boolean;
  action?: (props: any) => any;
  actionParameter?: string;
  icon?: ReactElement;
  label?: string;
  menuItems?: MenuItemType[];
  columnId?: string;
  isEnabled?: (row: RowType<TRow>) => boolean;
  shouldShowTextOnInvalidDate?: boolean;
  headerComponent?: ReactElement;
  hideByDefaultInPreferences?: boolean;
};

export type MenuItemType = {
  label: string;
  icon: ReactElement;
  action: (data: any) => any;
  actionParameter: string;
  minWidth?: string;
};

export enum RootTagName {
  Link = 'link',
  Div = 'div',
  Expand = 'expand'
}

export enum ColumnsVariant {
  Text = 'text',
  Boolean = 'boolean',
  Money = 'money',
  Menu = 'menu',
  Button = 'button',
  Chip = 'chip',
  Date = 'date',
  Image = 'image'
}

export type RowType<TRow = AnyObject> = TRow & {
  imgSrc?: string;
  isDisableRow?: boolean;
  border?: Partial<{
    isNeeded: boolean;
    color: string;
  }>;
  [key: string]: any;
};

export interface IRowContext {
  rowId: string;
}

export interface ICellContext {
  cellId: string;
}

export interface StyledRowIndicatorProps {
  color: string;
}

export interface RightComponentSettingParams {
  width: number;
}
